import * as React from "react";
import { useStaticQuery, graphql } from "gatsby";

export const makeDateForObjects = (listOfObjects, urlField, type = "") =>
  listOfObjects.map((x) => {
    const isRange = Boolean(x.endDate);
    const endDateValues = isRange
      ? { endDate: x.endDate, endDateApproximateness: x.endDateApproximateess }
      : {};
    return {
      title: x.title,
      isRange: isRange,
      date: x.date || x.dateApproximate,
      dateApproximateness: x.dateApproximateness,
      url:
        type === "timelineEvent"
          ? `/event/${x._id}`
          : type === "image"
          ? `/image/${x._id}`
          : type === "pdf"
          ? `/pdf/${x._id}`
          : x[urlField] && x[urlField]._rawAsset
          ? x[urlField]._rawAsset.url
          : null,
      original: x,
      type: type,
      ...endDateValues,
    };
  });

export const EverythingContext = React.createContext([]);

const EverythingProvider = (props) => {
  const everythingQuery = useStaticQuery(graphql`
    query {
      allSanityObjectPdf {
        nodes {
          _id
          date
          dateApproximateness
          endDate
          endDateApproximateness
          title
          pdfFile {
            _rawAsset(resolveReferences: { maxDepth: 10 })
          }
          keywords {
            _id
          }
          people {
            _id
          }
          mediaType {
            _id
          }
        }
      }
      allSanityObjectImage {
        nodes {
          _id
          date
          dateApproximateness
          title
          endDate
          endDateApproximateness
          mediaType {
            _id
          }
          keywords {
            _id
          }
          people {
            _id
          }
          imageFile {
            asset {
              gatsbyImageData(width: 200)
            }
          }
        }
      }
      allSanityTimelineEntry {
        nodes {
          _id
          title
          description
          endDate
          endDateApproximateness
          dateApproximateness
          date: startDate
          eventType
          people {
            _id
          }
          keywords {
            _id
          }
        }
      }
    }
  `);
  const thePdfs = everythingQuery.allSanityObjectPdf.nodes;
  const theImages = everythingQuery.allSanityObjectImage.nodes;
  const theTimelineEvents = everythingQuery.allSanityTimelineEntry.nodes;
  const allTheObjects = makeDateForObjects(thePdfs, "pdfFile", "pdf")
    .concat(makeDateForObjects(theImages, "imageFile", "image"))
    .concat(makeDateForObjects(theTimelineEvents, "", "timelineEvent"));
  return (
    <EverythingContext.Provider value={allTheObjects}>
      {props.children}
    </EverythingContext.Provider>
  );
};

export default EverythingProvider;
